import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { replace } from 'connected-react-router';

import { useActionDispatcher } from '../../hooks';
import VideoForm from './VideoForm';
import {
  createVideoRequest,
  initVideoRequest,
  resetCurrentVideo,
} from '../../store/modules/videos/actions';
import {
  isVideoPersistent,
  selectVideo,
} from '../../store/modules/videos/selectors';

const VideoCreate = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initVideoRequest());
    return () => {
      dispatch(resetCurrentVideo());
    };
  }, [dispatch]);

  const createVideo = useActionDispatcher(createVideoRequest);

  const persistent = useSelector(isVideoPersistent);
  const video = useSelector(selectVideo);

  useEffect(() => {
    if (persistent) {
      dispatch(replace(`/dashboard/admin/videos/${video.data!.id}`));
    }
  }, [persistent, video.data, dispatch]);

  return (
    <VideoForm
      creatingMode
      record={video}
      onSubmit={createVideo}
    />
  );
};

export default VideoCreate;
